import { ArrowRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Chapter, FadeUp } from "@/components/Reveal";

export default function FusionAcquisition() {
  return (
    <div className="bg-slate-50 min-h-screen flex flex-col" data-testid="fusion-acquisition-page">
      <Navbar />
      <main className="flex-1">
        <section className="bg-slate-900" data-testid="fusion-hero">
          <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-24 sm:py-28 lg:py-32">
            <FadeUp>
              <Chapter index="01" label="Fusion-Acquisition, Valorisation & Succession" />
            </FadeUp>
            <FadeUp delay={0.1}>
              <h1
                className="mt-8 max-w-3xl font-sans font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight"
                data-testid="fusion-title"
              >
                Révéler la valeur réelle. Protéger le patrimoine.
              </h1>
            </FadeUp>
            <FadeUp delay={0.2}>
              <p
                className="mt-8 max-w-2xl text-base sm:text-lg text-slate-300 leading-relaxed"
                data-testid="fusion-intro"
              >
                L'asymétrie d'information est le premier risque des opérations transactionnelles.
                Qu'il s'agisse d'un rachat (M&A), d'une cession ou d'une transmission familiale,
                ACS Corporate agit comme tiers de confiance pour garantir l'intégrité financière
                de l'opération. Si l'expert-comptable dresse la carte d'un territoire connu,
                notre pôle transactionnel agit comme l'ingénieur qui en sonde les profondeurs :
                nous évaluons la véritable richesse du filon et traquons les failles cachées
                avant la signature.
              </p>
            </FadeUp>
            <FadeUp delay={0.3}>
              <div
                data-testid="reserved-image-block"
                className="mt-14 aspect-video w-full rounded-2xl border border-dashed border-slate-700 bg-slate-800/50 flex items-center justify-center"
              >
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
                  Espace réservé — visuel à venir
                </span>
              </div>
            </FadeUp>
          </div>
        </section>

        <section className="bg-slate-50" data-testid="fusion-due-diligence">
          <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-24 sm:py-28 lg:py-32">
            <FadeUp>
              <Chapter index="02" label="Due Diligence" />
            </FadeUp>
            <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start">
              <FadeUp className="lg:col-span-5">
                <h2 className="font-sans font-extrabold text-slate-900 text-3xl sm:text-4xl leading-[1.15] tracking-tight">
                  Due Diligence &amp; Retraitement
                </h2>
              </FadeUp>
              <FadeUp delay={0.15} className="lg:col-span-7">
                <p className="w-full break-words whitespace-normal text-base sm:text-lg text-gray-600 leading-relaxed">
                  Pour sécuriser la rédaction des Garanties d'Actif et de Passif (GAP) ou des
                  protocoles d'accord, l'audit d'acquisition (Quality of Earnings) passe au crible
                  la qualité des flux de trésorerie de la cible. Les charges anormales sont
                  neutralisées pour faire émerger la rentabilité réelle, et les passifs latents
                  sont traqués, offrant ainsi des leviers de négociation tarifaire incontestables.
                </p>
              </FadeUp>
            </div>
          </div>
        </section>

        <section className="bg-slate-900" data-testid="fusion-valorisation">
          <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-24 sm:py-28 lg:py-32">
            <FadeUp>
              <Chapter index="03" label="Valorisation & Transmission" />
            </FadeUp>
            <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start">
              <FadeUp className="lg:col-span-5">
                <h2 className="font-sans font-extrabold text-white text-3xl sm:text-4xl leading-[1.15] tracking-tight">
                  Valorisation &amp; Transmission
                </h2>
              </FadeUp>
              <FadeUp delay={0.15} className="lg:col-span-7">
                <p className="w-full break-words whitespace-normal text-base sm:text-lg text-slate-300 leading-relaxed">
                  Dans le cadre de successions, de Pactes Dutreil ou de MBO, l'ingénierie
                  juridique doit s'appuyer sur des valorisations multi-critères robustes et
                  opposables à l'administration fiscale. Nous évaluons l'impact du risque Intuitu
                  Personae et modélisons la soutenabilité de la dette d'acquisition, afin de
                  garantir la pérennité de l'entreprise et du patrimoine transmis.
                </p>
                <a
                  href="/#contact"
                  data-testid="fusion-cta"
                  className="group mt-10 inline-flex items-center gap-2 bg-white text-slate-900 px-8 py-4 rounded-full font-medium hover:bg-slate-200 transition-colors duration-300"
                >
                  Confier un dossier
                  <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </FadeUp>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
